var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sign-up-success is-centered" },
    [
      _c("img", { attrs: { src: _vm.logo, alt: "logo" } }),
      _c("h2", { staticClass: "title is-4 has-text-white has-text-centered" }, [
        _vm._v("\n    ¡Verifica tu correo!\n  ")
      ]),
      _vm._m(0),
      _c(
        "button",
        {
          staticClass: "button is-uppercase is-primary",
          class: { "is-loading": _vm.loading },
          attrs: { disabled: _vm.loading },
          on: { click: _vm.resendActivationLink }
        },
        [_vm._v("\n    reenviar link de activación\n  ")]
      ),
      _c(
        "RouterLink",
        { staticClass: "has-text-white", attrs: { to: { name: "SignOut" } } },
        [_vm._v("\n    Iniciar sesión con otra cuenta\n  ")]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "content has-text-white has-text-centered" },
      [
        _vm._v("\n    Te hemos enviado un link para activar tu cuenta.\n    "),
        _c("br", { staticClass: "is-hidden-mobile" }),
        _vm._v(
          "\n    Es necesario que lo verifiques para iniciar sesión.\n    "
        ),
        _c("br"),
        _vm._v("\n    *Este link tiene una vigencia de 24 horas.\n  ")
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }